<template>
  <div class="card">
    <h4 class="margin-t-z margin-b-s">{{ $t('rsvpEdit.paymentInfo') }}</h4>
    <div class="payment-info">
      <div class="label">{{ $t('rsvpEdit.ccUsed') }}</div>
      <div class="value card-info" v-if="cardID !== null">
        <span v-bind:class="['cc-icon', cardTitle ]"></span>
        <span>**** {{ $store.state.rsvpEdit.editedRsvp.cardNumber }}</span>
      </div>
      <div class="value" v-else>{{ $t('rsvpEdit.paidThru') }}</div>
    </div>
    <div class="divider"></div>
    <div class="payment-info">
      <div class="label">{{ $t('rsvpEdit.fare') }}</div>
      <div class="value">${{ payment.fare.toFixed(2) }}</div>
    </div>
    <div class="payment-info" v-show="payment.travelInsurance > 0">
      <div class="label">{{$t('rsvpEdit.riderFee')}}:</div>
      <div class="value">${{ payment.travelInsurance.toFixed(2) }}</div>
    </div>
    <div class="payment-info" v-show="payment.airportFee > 0">
      <div class="label">{{ $t('rsvpEdit.airportFee') }}</div>
      <div class="value">${{ payment.airportFee.toFixed(2) }}</div>
    </div>
    <div class="payment-info" v-show="payment.gasFee > 0">
      <div class="label">{{ $t('rsvpEdit.fuelSurcharge') }}</div>
      <div class="value">${{ payment.gasFee.toFixed(2) }}</div>
    </div>
    <div class="payment-info" v-show="isAirportPickup && (isMeetAndGreet || isMeetAndGreetOnly || !isUSPhone) && edited.serviceCode && !mtech.enabled">
      <div class="label">{{ $t('rsvpEdit.mng') }}:</div>
      <div class="value">
        <span v-if="payment.pickupFee === 0">({{ $t('rsvpEdit.complimentary') }})</span>
        <span v-else>${{ payment.pickupFee.toFixed(2) }}</span>
      </div>
    </div>
    <div class="payment-info">
      <div class="label">{{ $t('rsvpEdit.tip') }}</div>
      <div class="value">${{ payment.tip.toFixed(2) }}</div>
    </div>
    <div class="payment-info">
      <div class="label">{{ $t('rsvpEdit.creditUsed') }}</div>
      <div class="value">
        <span v-if="payment.credits !== 0">-</span>
        ${{ payment.credits.toFixed(2) }}
      </div>
    </div>
    <div class="divider"></div>
    <div class="payment-info total">
      <div class="label">{{ $t('rsvpEdit.total') }}</div>
      <div class="value">${{ payment.total.toFixed(2) }}</div>
    </div>
  </div>
</template>

<script type="text/javascript">
/* global CONFIG */
import moment from 'moment'
import { isValidNumber } from 'libphonenumber-js'
export default {
  name: 'payment-info',
  data () {
    return {
      // travelInsuranceLabel: this.$t('rsvpEdit.travelInsu')
    }
  },
  computed: {
    charter () { return this.$store.state.reservation.charter },
    edited () { return this.$store.state.rsvpEdit.editedRsvp },
    cardID () { return this.edited.cardID },
    cardTitle () {
      let self = this
      let result = self.$store.state.rsvpEdit.editedRsvp.cardTitle
      if (result === null) {
        return ''
      }
      if (result === 'Master Card') {
        result = 'mastercard'
      }
      return result.toLowerCase()
    },
    isAirportPickup () { return this.edited.pickup.geofenceType === 'airport' },
    isMeetAndGreet () { return this.edited.pickupType === 'MeetAndGreet' || !this.isUSPhone || this.isMeetAndGreetOnly },
    isMeetAndGreetOnly () {
      let self = this
      let services = self.$store.state.rsvpEdit.serviceSelection.services
      if (services === null || this.edited.isLyft) return false

      let serviceCode = self.$store.state.rsvpEdit.editedRsvp.serviceCode
      let service = services[serviceCode]
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService !== null) service = selectedService

      return service.meetAndGreet && !service.curbside
    },
    payment () {
      let self = this
      let originalPayment = self.$store.state.rsvpEdit.editedRsvp.payment
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      let passengers = self.$store.state.rsvpEdit.editedRsvp.passengers
      let luggage = self.$store.state.rsvpEdit.editedRsvp.luggage
      let rsvpEdit = self.$store.state.rsvpEdit

      // let oldExtraStops = self.$store.state.rsvpEdit.editedRsvp.extraStops
      // let newExtraStops = this.$store.state.rsvpDetails.edit.details.tripInfo.extraStops
      // let hasExtraStopChanges = false
      // if (oldExtraStops.length) {
      //   if (oldExtraStops.length !== newExtraStops.length) {
      //     hasExtraStopChanges = true
      //   } else {
      //     oldExtraStops.forEach((stop, index) => {
      //       if (stop.lat !== newExtraStops[index].lat || stop.lng !== newExtraStops[index].lng) {
      //         hasExtraStopChanges = true
      //       }
      //     })
      //   }
      // }
      let charterSameData = true
      if (self.charter.enabled) {
        let orig = self.$store.state.rsvpEdit.originalRsvp
        let origPickup = self.$store.state.rsvpEdit.originalRsvp.pickup
        let pickup = self.charter.pickup
        if (origPickup.geofenceType === 'airport' && origPickup.geofenceId !== pickup.geofenceId) {
          charterSameData = false
        }
        if (origPickup.geofenceType !== 'airport' &&
          (origPickup.lat !== pickup.lat || origPickup.lng !== pickup.lng)
        ) {
          charterSameData = false
        }
        if (orig.pickupTime !== self.charter.startDate) {
          charterSameData = false
        }
        let startDate = moment(this.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(this.charter.endDate, 'MM/DD/YYYY hh:mmA')
        let etaInSec = parseInt(endDate.diff(startDate, 'seconds'))
        if (orig.eta !== etaInSec ||
          (rsvpEdit.serviceSelection.selectedService && orig.serviceCode !== rsvpEdit.serviceSelection.selectedService.code)
        ) {
          charterSameData = false
        }
      }

      if (!rsvpEdit.serviceSelection.selectedService && !rsvpEdit.editedRsvp.serviceCode && !this.edited.isLyft) {
        return {
          fare: 0,
          airportFee: 0,
          travelInsurance: 0,
          pickupFee: 0,
          gasFee: 0,
          tip: 0,
          credits: 0,
          total: 0
        }
      }

      if ((selectedService === null ||
        (selectedService && selectedService.prices.length < passengers) ||
        (selectedService && luggage > selectedService.maxLuggage)) && !self.charter.enabled ||
        (self.charter.enabled && charterSameData)
      ) {
        let pickupFee = originalPayment.pickupFee
        let services = self.$store.state.rsvpEdit.serviceSelection.services
        if (services !== null) {
          let serviceCode = self.$store.state.rsvpEdit.editedRsvp.serviceCode
          pickupFee = services[serviceCode] ? services[serviceCode].pickupFee : 0
        }
        let total = (originalPayment.fare + originalPayment.airportFee + self.$store.state.rsvpEdit.originalRsvp.gasFee + originalPayment.travelInsurance + (self.isMeetAndGreet ? pickupFee : 0) + originalPayment.tip) - originalPayment.promo
        total = total < 0 ? 0 : total
        return {
          fare: originalPayment.fare,
          airportFee: originalPayment.airportFee,
          travelInsurance: originalPayment.travelInsurance,
          pickupFee: pickupFee,
          gasFee: self.$store.state.rsvpEdit.originalRsvp.gasFee,
          tip: originalPayment.tip,
          credits: originalPayment.promo,
          total: total
        }
      }
      let fare = self.getFare()
      if (self.charter.enabled) {
        selectedService = rsvpEdit.serviceSelection.services[rsvpEdit.editedRsvp.serviceCode]
      }
      let total = (fare + selectedService.airportFee + selectedService.gasFee + selectedService.travelInsurance + (self.isMeetAndGreet ? selectedService.pickupFee : 0) + originalPayment.tip) - originalPayment.promo
      total = total < 0 ? 0 : total
      return {
        fare: fare,
        airportFee: selectedService.airportFee,
        travelInsurance: selectedService.travelInsurance,
        pickupFee: selectedService.pickupFee,
        gasFee: selectedService.gasFee,
        tip: originalPayment.tip,
        credits: originalPayment.promo,
        total: total
      }
    },
    isUSPhone () {
      let userPhone = this.$store.state.rsvpEdit.originalRsvp.consumer.phones[0]
      userPhone = userPhone.countryCode + userPhone.phoneNumber
      return isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
    },
    mtech () { return this.$store.state.reservation.mtech },
    _lang () { return this.$i18n.locale }
  },
  methods: {
    getHolidayPrice () {
      if (!CONFIG.useOldQuatation) { return 0 }
      return 0
    },
    getFare () {
      let self = this
      let rsvpEdit = self.$store.state.rsvpEdit
      let passengers = rsvpEdit.editedRsvp.passengers
      let service = rsvpEdit.serviceSelection.selectedService

      let holidayPrice = self.getHolidayPrice(service)
      let price = 0
      if (self.charter.enabled) {
        let code = rsvpEdit.serviceSelection.selectedService ? rsvpEdit.serviceSelection.selectedService.code : rsvpEdit.editedRsvp.serviceCode
        price = rsvpEdit.serviceSelection.services[code].prices[passengers - 1].price
      } else {
        price = service.prices[passengers - 1].price
      }
      if (holidayPrice > 0) {
        price = service.prices[passengers - 1].original + holidayPrice
      }
      return price
    }
  },
  watch: {
    'edited.serviceCode': function () {
      this.$forceUpdate()
    },
    _lang () {

    }
  },
  mounted: function () {
    if (this.$store.state.TravelInsuranceLabel) {
      // this.travelInsuranceLabel = this.$store.state.TravelInsuranceLabel
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/CreditCardIcons.css";
@import "../../assets/scss/CreditCardIcons.scss";
.payment-info {
  position: relative;
  padding: 2px 0;

  & > * {
    display: inline-block;
    vertical-align: middle;
  }

  & .label {
    color: #777;
    width: 130px;
    margin-right: 10px;
    text-align: right;
    font-size: 14px;
  }

  & .value {
    font-size: 16px;
  }

  & .card-info {
    & > span {
      display: inline-block;
      vertical-align: middle;
    }
  }

  &.total {
    & .label { font-size: 16px; }
    & .value {
      font-size: 20px;
      font-weight: 700;
    }
  }
}

.divider {
  display: block;
  height: 0;
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.2);
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// PaymentInformation.vue?7219c2e0